import React from 'react'

// Require SSO (organization_domains.sso_required), explained where it is
// switched (owner 2026-10-06). What it does, exactly: a password sign-in at
// the domain is refused while the domain routes, SSO is reachable for it,
// and the rule is enforced -- so when SSO stops working, passwords work
// again (rapid-api-auth, api/ddd/common/sso-required).
export const requireSSOHint = domain =>
  `When on, people at ${domain} must sign in with SSO, not a password. If SSO stops working, passwords work again.`

// The switch with its explanation under it, as its accessible description.
// The organization's own Authentication page and staff's organization SSO
// tab both show it on each domain row.
export const RequireSSOSwitch = ({ id, domain, checked, disabled, onChange }) =>
  <div className="d-grid gap-1">
    <div className="form-check form-switch mb-0">
      <input className="form-check-input" type="checkbox" id={id} checked={!!checked} disabled={disabled} onChange={onChange} aria-describedby={`${id}-hint`} />
      <label className="form-check-label" htmlFor={id}>Require SSO</label>
    </div>
    <p className="sw-hint m-0" id={`${id}-hint`}>{requireSSOHint(domain)}</p>
  </div>
